import { Button, Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle, Text } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import s from "./IosInstallSheet.module.css";

export interface IosInstallSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

function ShareIcon() {
  return (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
      <path d="M12 3v12" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 7l4-4 4 4" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="5" y="10" width="14" height="11" rx="2" />
    </svg>
  );
}

function AddToHomeIcon() {
  return (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="4" />
      <path d="M12 8v8M8 12h8" strokeLinecap="round" />
    </svg>
  );
}

/**
 * The Share icon's position varies by iOS version and browser (bottom bar on
 * iPhone Safari, top-right in Chrome/Edge on iOS), so the copy stays generic
 * ("selaimen palkissa") rather than naming a side.
 */
export function IosInstallSheet({ open, onOpenChange }: IosInstallSheetProps) {
  const { t } = useTranslation("client");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={s.sheet}>
        <DialogTitle className={s.title}>{t("install.title", "Asenna Ferrivia puhelimeesi")}</DialogTitle>
        <DialogDescription className={s.description}>
          {t("install.ios.description", "Lisää Ferrivia kotivalikkoosi kahdessa vaiheessa")}
        </DialogDescription>

        <ol className={s.steps}>
          <li className={s.step}>
            <span className={s.icon} aria-hidden="true">
              <ShareIcon />
            </span>
            <Text size="sm">{t("install.ios.step1", "Paina jakokuvaketta selaimen palkissa")}</Text>
          </li>
          <li className={s.step}>
            <span className={s.icon} aria-hidden="true">
              <AddToHomeIcon />
            </span>
            <Text size="sm">{t("install.ios.step2", 'Valitse "Lisää Koti-valikkoon"')}</Text>
          </li>
        </ol>

        <DialogClose asChild>
          <Button variant="primary" className={s.done}>
            {t("install.ios.done", "Selvä")}
          </Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}
